// extracted by mini-css-extract-plugin
module.exports = {"otpVerification":"v1_otpVerification__O_OPU"};